module.exports = __webpack_public_path__ + "img/paralax.e018d501.png";